module.exports = __webpack_public_path__ + "static/img/corporate.da67d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corporateCulture/corporate.jpg
// module id = EA57
// module chunks = 1